import navigate from '@/utils/navigate';
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import * as React from 'react';

const Component = props => {
    const { scheduled, total } = props.data;

    return (
        <Card>
            <CardContent sx={{ height: 260 }}>
                <Typography color="text.secondary" gutterBottom sx={{ fontSize: 14 }}>
                    Reports
                </Typography>
                <Typography component="div" variant="h5">
                    Total: {total}
                </Typography>
                <br/>
                <Typography color="text.secondary" sx={{ mb: 0.5 }}>
                    Scheduled: {scheduled}
                </Typography>
            </CardContent>
            <CardActions sx={{ height: 20 }}>
                <Button onClick={() => navigate('/reports')}>View Reports</Button>
            </CardActions>
        </Card>
    );
};

export default Component;
